import React, { useEffect, useState } from "react";
import { Plus, Search, Trash2, Edit2, X } from "lucide-react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import axios, { all } from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ApiUrl from "../Environment/ApiUrl";

const BranchTable = () => {
  const [branchtableData, setBranchtableData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [generatedata, setGeneratedata] = useState("");

  // Open and close modal functions
  const openModal = () => setShowModal(true);
  const closeModal = () => {
    setShowModal(false);
    setFieldErrors({});
  };

  // Field validation errors
  const [fieldErrors, setFieldErrors] = useState({
    branch_name: "",
    Gst_No: "",
    mobile_number: "",
    email_id: "",
    address: "",
  });

  // Validate form fields
  const validateField = (name, value) => {
    let error = "";

    switch (name) {
      case "branch_name":
        if (!value.trim()) error = "Branch name is required";
        else if (value.length > 50) error = "Branch name too long";
        break;
      case "Gst_No":
        if (!value.trim()) error = "Gst_No is required";
        else if (value.length > 50) error = "Gst_No  too long";
        break;
      case "mobile_number":
        if (!value.trim()) error = "Mobile number is required";
        else if (!/^\d{10}$/.test(value)) error = "Invalid mobile number";
        break;
      case "email_id":
        if (!value.trim()) error = "Email is required";
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value))
          error = "Invalid email format";
        break;
      case "address":
        if (!value.trim()) error = "Address is required";
        else if (value.length > 200) error = "Address too long";
        break;
      default:
        break;
    }

    return error;
  };

  // Handle field blur validation
  const handleBlur = (e) => {
    const { name, value } = e.target;
    const error = validateField(name, value);

    setFieldErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  // Auto generate code
  useEffect(() => {
    fetchNextBranchId();
  }, []);

  const fetchNextBranchId = async () => {
    try {
      const response = await axios.get(
        `${ApiUrl}/branch_data.php/generate-branch-code`
      );
      setGeneratedata(response.data.branch_id);
      setBranchData((prev) => ({
        ...prev,
        branch_id: response.data?.branch_id,
      }));
    } catch (error) {
      console.error("Error fetching branch ID:", error);
      toast.error("Failed to fetch branch ID");
    }
  };

  const [branchData, setBranchData] = useState({
    branch_id: "",
    branch_name: "",
    Gst_No: "",
    mobile_number: "",
    email_id: "",
    address: "",
    status: "Active",
  });

  useEffect(() => {
    fetchdata();
  }, []);

  const fetchdata = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/branch_data.php`);
      if (response.data && response.data.data) {
        setBranchtableData(response.data.data);
      } else {
        setBranchtableData([]);
      }
    } catch (error) {
      console.log("error is fetching", error);
      toast.error("Failed to fetch branch data");
      setBranchtableData([]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate all fields before submission
    const errors = {};
    let isValid = true;

    Object.keys(branchData).forEach((key) => {
      if (key !== "branch_id" && key !== "status") {
        const error = validateField(key, branchData[key]);
        if (error) {
          errors[key] = error;
          isValid = false;
        }
      }
    });

    setFieldErrors(errors);

    if (!isValid) {
      toast.error("Please fix form errors before submitting");
      return;
    }

    try {
      const formData = {
        branch_id: branchData.branch_id,
        branch_name: branchData.branch_name,
        Gst_No: branchData.Gst_No,
        mobile_number: branchData.mobile_number,
        email_id: branchData.email_id,
        address: branchData.address,
        status: branchData.status,
      };

      const response = await axios.post(`${ApiUrl}/branch_data.php`, formData);
      toast.success("Branch added successfully!");
      setBranchData({
        branch_id: "",
        branch_name: "",
        Gst_No: "",
        mobile_number: "",
        email_id: "",
        address: "",
        status: "Active",
      });
      fetchNextBranchId();
      fetchdata();
      setShowModal(false);
      setFieldErrors({});
    } catch (error) {
      console.log("Error Post data", error);
      toast.error("Failed to add branch");
    }
  };

  // Delete state
  const [deleteShowModals, setDeleteShowModals] = useState(false);
  const [getdeleteid, setdeleteid] = useState("");
  const [getdeletename, setdeletename] = useState("");

  const handleOpenModal = (id, branch_id) => {
    setdeleteid(id);
    setdeletename(branch_id);
    setDeleteShowModals(true);
  };

  const handleCloseModal = () => {
    setDeleteShowModals(false);
  };

  const handleDelete = async () => {
    try {
      const response = await axios.delete(`${ApiUrl}/branch_data.php`, {
        data: { id: getdeleteid },
      });
      toast.success(`Branch ${getdeletename} deleted successfully!`);
      setDeleteShowModals(false);
      fetchdata();
    } catch (error) {
      console.error("Error deleting data:", error.message);
      toast.error("Failed to delete branch");
    }
  };

  // Update state
  const [updateModal, setUpdatemodal] = useState(false);
  const [updateFieldErrors, setUpdateFieldErrors] = useState({});
  const [updatedata, setUpdatedata] = useState({
    branch_id: "",
    branch_name: "",
    Gst_No: "",
    mobile_number: "",
    email_id: "",
    address: "",
    status: "Active",
  });
  const [updateid, setUpdateid] = useState();

  const handleupdate = (id, data) => {
    setUpdatemodal(true);
    setUpdateid(id);
    setUpdatedata({
      branch_id: data.branch_id,
      branch_name: data.branch_name,
      Gst_No: data.Gst_No,
      mobile_number: data.mobile_number,
      email_id: data.email_id,
      address: data.address,
      status: data.status,
    });
    setUpdateFieldErrors({});
  };

  // Handle update field blur validation
  const handleUpdateBlur = (e) => {
    const { name, value } = e.target;
    const error = validateField(name, value);

    setUpdateFieldErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  const Branchupdate = async (e) => {
    e.preventDefault();

    // Validate all fields before submission
    const errors = {};
    let isValid = true;

    Object.keys(updatedata).forEach((key) => {
      if (key !== "branch_id" && key !== "status") {
        const error = validateField(key, updatedata[key]);
        if (error) {
          errors[key] = error;
          isValid = false;
        }
      }
    });

    setUpdateFieldErrors(errors);

    if (!isValid) {
      toast.error("Please fix form errors before updating");
      return;
    }

    try {
      const formdata = {
        branch_id: updatedata.branch_id,
        branch_name: updatedata.branch_name,
        Gst_No: updatedata.Gst_No,
        mobile_number: updatedata.mobile_number,
        email_id: updatedata.email_id,
        address: updatedata.address,
        status: updatedata.status,
      };

      const response = await axios.put(`${ApiUrl}/branch_data.php`, {
        id: updateid,
        ...formdata,
      });
      toast.success("Branch updated successfully!");
      setUpdatemodal(false);
      fetchdata();
    } catch (error) {
      console.log("update data error", error.message);
      toast.error("Failed to update branch");
    }
  };

  // Search and pagination
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);

  const filteredBranches = branchtableData.filter((branch) =>
    Object.values(branch)
      .join(" ")
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredBranches.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentBranches = filteredBranches.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  return (
    <div className="bg-white font-sans">
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
      />

      {/* Header */}
      <div className="p-3 p-md-4 bg-white">
        <div className="d-flex justify-content-between align-items-center">
          <h2 className="m-0 fs-5 fw-semibold text-dark">Branches</h2>
          {/* <button
            className="btn btn-danger d-flex align-items-center gap-2"
            onClick={openModal}
          >
            <Plus size={18} />
            Add Branch
          </button> */}
        </div>
      </div>

      {/* Main Card Container */}
      <div className="card mx-3 mx-md-4 border">
        {/* Controls Row */}
        <div className="card-header bg-white d-flex justify-content-between align-items-center p-3 border-bottom">
          <div
            className="d-flex align-items-center gap-2"
            style={{ height: "36px", width: "120px" }}
          >
            <div
              className="d-flex align-items-center justify-content-center"
              style={{ height: "28px", width: "14px" }}
            >
              <svg width="14" height="14" viewBox="0 0 12 12" fill="none">
                <rect x="1" y="1" width="3" height="3" fill="#666" />
                <rect x="1" y="5" width="3" height="3" fill="#666" />
                <rect x="1" y="9" width="3" height="2" fill="#666" />
                <rect x="5" y="1" width="6" height="1" fill="#666" />
                <rect x="5" y="3" width="6" height="1" fill="#666" />
                <rect x="5" y="5" width="6" height="1" fill="#666" />
                <rect x="5" y="7" width="6" height="1" fill="#666" />
                <rect x="5" y="9" width="6" height="1" fill="#666" />
              </svg>
            </div>
            <select
              className="border-0 bg-transparent text-dark form-select form-select-sm"
              style={{
                boxShadow: "none",
                outline: "none",
                lineHeight: "1.1",
                height: "28px",
                cursor: "pointer",
                width: "80px",
                paddingTop: "0",
                paddingBottom: "0",
              }}
              value={itemsPerPage}
              onChange={(e) => {
                setItemsPerPage(Number(e.target.value));
                setCurrentPage(1);
              }}
            >
              <option value="5">Show 5</option>
              <option value="10">Show 10</option>
              <option value="25">Show 25</option>
              <option value={filteredBranches.length}>Show All</option>
            </select>
          </div>

          {/* Search */}
          <div className="position-relative" style={{ width: "280px" }}>
            <input
              type="text"
              placeholder="Search"
              className="w-100 ps-3 pe-5 py-2 border rounded form-control"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <Search
              size={18}
              className="position-absolute top-50 end-0 translate-middle-y me-3 text-danger"
              style={{ pointerEvents: "none" }}
            />
          </div>
        </div>

        {/* Table Container */}
        <div className="card-body p-0">
          {/* Table */}
          <div className="table-responsive">
            <table className="table table-hover mb-0 text-center">
              <thead>
                <tr>
                  <th
                    style={{ backgroundColor: "#d3d3d3" }}
                    className="p-3 fw-semibold small"
                  >
                    S.No
                  </th>
                  <th
                    style={{ backgroundColor: "#d3d3d3" }}
                    className="p-3 fw-semibold small"
                  >
                    Branch ID
                  </th>
                  <th
                    style={{ backgroundColor: "#d3d3d3" }}
                    className="p-3 fw-semibold small"
                  >
                    Branch Name
                  </th>
                  <th
                    style={{ backgroundColor: "#d3d3d3" }}
                    className="p-3 fw-semibold small"
                  >
                    Gst No
                  </th>
                  <th
                    style={{ backgroundColor: "#d3d3d3" }}
                    className="p-3 fw-semibold small"
                  >
                    Mobile Number
                  </th>
                  {/* <th
                    style={{ backgroundColor: "#d3d3d3" }}
                    className="p-3 fw-semibold small"
                  >
                    Email
                  </th> */}
                  {/* <th
                    style={{ backgroundColor: "#d3d3d3" }}
                    className="p-3 fw-semibold small"
                  >
                    Address
                  </th> */}
                  <th
                    style={{ backgroundColor: "#d3d3d3" }}
                    className="p-3 fw-semibold small"
                  >
                    Status
                  </th>
                  <th
                    style={{ backgroundColor: "#d3d3d3" }}
                    className="p-3 fw-semibold small"
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentBranches.length > 0 ? (
                  currentBranches.map((items, index) => (
                    <tr key={index} style={{ fontSize: "14px" }}>
                      <td>{startIndex + index + 1}</td>
                      <td>{items.branch_id}</td>
                      <td>{items.branch_name}</td>
                      <td>{items.Gst_No}</td>
                      <td>{items.mobile_number}</td>
                      {/* <td>{items.email_id}</td> */}
                      {/* <td>{items.address}</td> */}
                      <td className="small">
                        <span
                          className={`d-inline-flex align-items-center gap-1 px-2 py-1 rounded-pill small fw-medium ${items.status === "Active"
                            ? "bg-success bg-opacity-10 text-success"
                            : "bg-danger bg-opacity-10 text-danger"
                            }`}
                        >
                          {items.status}
                        </span>
                      </td>
                      <td className="small">
                        <div className="d-flex">
                          {/* <button
                            className="p-1 border-0 bg-transparent cursor-pointer text-muted"
                            onClick={() =>
                              handleOpenModal(items.id, items.branch_id)
                            }
                          >
                            <Trash2 size={16} />
                          </button> */}
                          <button
                            className="p-1 border-0 bg-transparent cursor-pointer text-muted"
                            onClick={() => handleupdate(items.id, items)}
                          >
                            <Edit2 size={16} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={9} className="text-center p-5">
                      No data available.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {itemsPerPage < filteredBranches.length && (
            <div className="card-footer bg-white d-flex justify-content-between align-items-center border-top">
              {/* Previous */}
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                className={`btn btn-sm d-flex align-items-center gap-2 ${currentPage === 1
                  ? "bg-light text-muted"
                  : "bg-white text-dark"
                  }`}
              >
                <FaChevronLeft size={14} />
                <span className="ms-1 d-none d-md-inline">Previous</span>
              </button>

              {/* Page Numbers */}
              <div className="d-flex gap-1">
                {Array.from({ length: totalPages }, (_, i) => i + 1)
                  .filter((pageNum) => {
                    // Always show first and last page
                    if (pageNum === 1 || pageNum === totalPages) return true;
                    // Show pages around current page
                    if (
                      pageNum >= currentPage - 2 &&
                      pageNum <= currentPage + 2
                    )
                      return true;
                    return false;
                  })
                  .map((pageNum, index, array) => {
                    // Add ellipsis between gaps
                    const prev = array[index - 1];
                    if (prev && pageNum - prev > 1) {
                      return (
                        <React.Fragment key={pageNum}>
                          <span className="px-2 py-1">...</span>
                          <button
                            onClick={() => setCurrentPage(pageNum)}
                            className={`btn btn-sm ${currentPage === pageNum
                              ? "bg-danger bg-opacity-10 text-danger"
                              : "bg-white text-dark"
                              }`}
                          >
                            {pageNum}
                          </button>
                        </React.Fragment>
                      );
                    }
                    return (
                      <button
                        key={pageNum}
                        onClick={() => setCurrentPage(pageNum)}
                        className={`btn btn-sm ${currentPage === pageNum
                          ? "bg-danger bg-opacity-10 text-danger"
                          : "bg-white text-dark"
                          }`}
                      >
                        {pageNum}
                      </button>
                    );
                  })}
              </div>

              {/* Next */}
              <button
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={currentPage === totalPages}
                className={`btn btn-sm d-flex align-items-center gap-2 ${currentPage === totalPages
                  ? "bg-light text-muted"
                  : "bg-white text-dark"
                  }`}
              >
                <span className="ms-1 d-none d-md-inline">Next</span>
                <FaChevronRight size={14} />
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Add Branch Modal */}
      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        style={{
          display: showModal ? "block" : "none",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
        tabIndex="-1"
        aria-labelledby="addCustomerModalLabel"
        aria-hidden={!showModal}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div
            className="modal-content"
            style={{ backgroundColor: " rgb(255, 240, 245)" }}
          >
            <div className="modal-header bg-pink-light border-bottom-0">
              <h6 className="modal-title m-0  fw-semibold">Add Branch</h6>
              <button
                type="button"
                className="btn btn-close"
                onClick={closeModal}
              ></button>
            </div>

            <div className="modal-body bg-pink-light">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      Branch ID <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      name="branch_id"
                      value={generatedata}
                      readOnly
                      placeholder="Enter Branch ID"
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      Branch Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className={`form-control form-control-sm ${fieldErrors.branch_name ? "is-invalid" : ""
                        }`}
                      name="branch_name"
                      value={branchData.branch_name}
                      onChange={(e) =>
                        setBranchData({
                          ...branchData,
                          branch_name: e.target.value,
                        })
                      }
                      onBlur={handleBlur}
                      placeholder="Enter Branch Name"
                    />
                    {fieldErrors.branch_name && (
                      <div className="invalid-feedback d-flex align-items-center">
                        {fieldErrors.branch_name}
                      </div>
                    )}
                  </div>

                  <div className="col-md-6">
                    <label className="form-label small fw-medium mt-2">
                      Mobile Number <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className={`form-control form-control-sm ${fieldErrors.mobile_number ? "is-invalid" : ""
                        }`}
                      name="mobile_number"
                      value={branchData.mobile_number}
                      onChange={(e) => {
                        // Allow only digits
                        const numericValue = e.target.value.replace(/\D/g, "");
                        setBranchData({
                          ...branchData,
                          mobile_number: numericValue,
                        });
                      }}
                      onBlur={handleBlur}
                      placeholder="Enter Mobile Number"
                      maxLength={10} // optional: limit to 10 digits
                    />

                    {fieldErrors.mobile_number && (
                      <div className="invalid-feedback d-flex align-items-center">
                        {fieldErrors.mobile_number}
                      </div>
                    )}
                  </div>
                  <div className="col-12">
                    <label className="form-label small fw-medium mt-2">
                      Email ID <span className="text-danger">*</span>
                    </label>
                    <input
                      type="email"
                      className={`form-control form-control-sm ${fieldErrors.email_id ? "is-invalid" : ""
                        }`}
                      name="email_id"
                      value={branchData.email_id}
                      onChange={(e) =>
                        setBranchData({
                          ...branchData,
                          email_id: e.target.value,
                        })
                      }
                      onBlur={handleBlur}
                      placeholder="Enter Email ID"
                    />
                    {fieldErrors.email_id && (
                      <div className="invalid-feedback d-flex align-items-center">
                        {fieldErrors.email_id}
                      </div>
                    )}
                  </div>
                  <div className="col-12">
                    <label className="form-label small fw-medium mt-2">
                      Address <span className="text-danger">*</span>
                    </label>
                    <textarea
                      className={`form-control form-control-sm ${fieldErrors.address ? "is-invalid" : ""
                        }`}
                      name="address"
                      value={branchData.address}
                      onChange={(e) =>
                        setBranchData({
                          ...branchData,
                          address: e.target.value,
                        })
                      }
                      onBlur={handleBlur}
                      placeholder="Enter Address"
                      rows="2"
                    />
                    {fieldErrors.address && (
                      <div className="invalid-feedback d-flex align-items-center">
                        {fieldErrors.address}
                      </div>
                    )}
                  </div>
                  <div className="col-12">
                    <label className="form-label small fw-medium mt-2">
                      Branch Status
                    </label>
                    <select
                      className="form-select form-select-sm"
                      name="status"
                      value={branchData.status}
                      onChange={(e) =>
                        setBranchData({ ...branchData, status: e.target.value })
                      }
                    >
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </select>
                  </div>
                </div>
              </form>
            </div>

            <div className="modal-footer border-top-0">
              <button
                type="button"
                className="btn btn-sm btn-danger"
                onClick={closeModal}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-sm btn-success"
                onClick={handleSubmit}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Delete Modal */}
      <div
        className={`modal fade ${deleteShowModals ? "show" : ""}`}
        style={{
          display: deleteShowModals ? "block" : "none",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
        tabIndex="-1"
        aria-labelledby="deleteConfirmModalLabel"
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-confirm">
          <div className="modal-content">
            <div className="modal-body text-center">
              <div className="d-flex justify-content-center mb-3">
                <div
                  className="icon-box bg-light rounded-circle d-flex align-items-center justify-content-center"
                  style={{ width: "80px", height: "80px" }}
                >
                  <i className="bi bi-exclamation-triangle text-danger fs-2"></i>
                </div>
              </div>
              <h4 className="modal-title mb-3">Are you sure?</h4>
              <h6 className="mb-4">
                Do you really want to delete this{" "}
                <span className="text-primary">{getdeletename}</span>?
              </h6>
              <div className="d-flex btn-group">
                <button
                  type="button"
                  className="btn btn-secondary btn-sm flex-grow-1"
                  onClick={handleCloseModal}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-danger btn-sm flex-grow-1 mx-2"
                  onClick={handleDelete}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Update Branch Modal */}
      <div
        className={`modal fade ${updateModal ? "show" : ""}`}
        style={{
          display: updateModal ? "block" : "none",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
        tabIndex="-1"
        aria-labelledby="updateCustomerModalLabel"
        aria-hidden={!updateModal}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div
            className="modal-content rounded"
            style={{ backgroundColor: " rgb(255, 240, 245)" }}
          >
            <div className="modal-header bg-pink-light border-bottom-0">
              <h5 className="modal-title m-0 fw-semibold">Update Branch</h5>
              <button
                type="button"
                className="btn btn-close"
                onClick={() => setUpdatemodal(false)}
              ></button>
            </div>

            <div className="modal-body bg-pink-light">
              <form onSubmit={Branchupdate}>
                <div className="row">
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      Branch ID <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      name="branch_id"
                      value={updatedata.branch_id}
                      readOnly
                      placeholder="Enter Branch ID"
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      Branch Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className={`form-control form-control-sm ${updateFieldErrors.branch_name ? "is-invalid" : ""
                        }`}
                      name="branch_name"
                      value={updatedata.branch_name}
                      onChange={(e) =>
                        setUpdatedata({
                          ...updatedata,
                          branch_name: e.target.value,
                        })
                      }
                      onBlur={handleUpdateBlur}
                      placeholder="Enter Branch Name"
                    />
                    {updateFieldErrors.branch_name && (
                      <div className="invalid-feedback d-flex align-items-center">
                        <X size={14} className="me-1" />
                        {updateFieldErrors.branch_name}
                      </div>
                    )}
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium mt-2">
                      Gst No <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className={`form-control form-control-sm ${updateFieldErrors.Gst_No ? "is-invalid" : ""
                        }`}
                      name="Gst_No"
                      value={updatedata.Gst_No}
                      onChange={(e) =>
                        setUpdatedata({
                          ...updatedata,
                          Gst_No: e.target.value,
                        })
                      }
                      onBlur={handleUpdateBlur}
                      placeholder="Enter Gst_No"
                    />
                    {updateFieldErrors.Gst_No && (
                      <div className="invalid-feedback d-flex align-items-center">
                        <X size={14} className="me-1" />
                        {updateFieldErrors.Gst_No}
                      </div>
                    )}
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium mt-2">
                      Mobile Number <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className={`form-control form-control-sm ${updateFieldErrors.mobile_number ? "is-invalid" : ""
                        }`}
                      name="mobile_number"
                      value={updatedata.mobile_number}
                      onChange={(e) => {
                        // Allow only digits and limit to 10
                        const digitsOnly = e.target.value
                          .replace(/\D/g, "")
                          .slice(0, 10);
                        setUpdatedata({
                          ...updatedata,
                          mobile_number: digitsOnly,
                        });
                      }}
                      onBlur={handleUpdateBlur}
                      placeholder="Enter Mobile Number"
                      maxLength={10}
                    />

                    {updateFieldErrors.mobile_number && (
                      <div className="invalid-feedback d-flex align-items-center">
                        <X size={14} className="me-1" />
                        {updateFieldErrors.mobile_number}
                      </div>
                    )}
                  </div>
                  <div className="col-12">
                    <label className="form-label small fw-medium mt-2">
                      Email ID <span className="text-danger">*</span>
                    </label>
                    <input
                      type="email"
                      className={`form-control form-control-sm ${updateFieldErrors.email_id ? "is-invalid" : ""
                        }`}
                      name="email_id"
                      value={updatedata.email_id}
                      onChange={(e) =>
                        setUpdatedata({
                          ...updatedata,
                          email_id: e.target.value,
                        })
                      }
                      onBlur={handleUpdateBlur}
                      placeholder="Enter Email ID"
                    />
                    {updateFieldErrors.email_id && (
                      <div className="invalid-feedback d-flex align-items-center">
                        <X size={14} className="me-1" />
                        {updateFieldErrors.email_id}
                      </div>
                    )}
                  </div>
                  <div className="col-12">
                    <label className="form-label small fw-medium mt-2">
                      Address <span className="text-danger">*</span>
                    </label>
                    <textarea
                      className={`form-control form-control-sm ${updateFieldErrors.address ? "is-invalid" : ""
                        }`}
                      name="address"
                      value={updatedata.address}
                      onChange={(e) =>
                        setUpdatedata({
                          ...updatedata,
                          address: e.target.value,
                        })
                      }
                      onBlur={handleUpdateBlur}
                      placeholder="Enter Address"
                      rows="2"
                    />
                    {updateFieldErrors.address && (
                      <div className="invalid-feedback d-flex align-items-center">
                        <X size={14} className="me-1" />
                        {updateFieldErrors.address}
                      </div>
                    )}
                  </div>
                  <div className="col-12">
                    <label className="form-label small fw-medium">
                      Branch Status
                    </label>
                    <select
                      className="form-select form-select-sm"
                      name="status"
                      value={updatedata.status}
                      onChange={(e) =>
                        setUpdatedata({ ...updatedata, status: e.target.value })
                      }
                    >
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </select>
                  </div>
                </div>
              </form>
            </div>

            <div className="modal-footer border-top-0">
              <button
                type="button"
                className="btn btn-sm btn-danger"
                onClick={() => setUpdatemodal(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-sm btn-success"
                onClick={Branchupdate}
              >
                Update
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BranchTable;
